export enum ErrorCode {
  MIGRATION_ERROR = 100,
  SCHEMA_VALIDATE_ERROR,
}
